import React from "react";
function Add()
{
    return(
        <>
        <h2>Add</h2>
        </>
    )
}
export default Add; 